<template>
	<heading />
	<content class="">
		<div class="row">
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="row d-none">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<font-awesome-icon class="nav-icon" :icon="['fas', 'map']" />
								National Locations&nbsp;&nbsp;
							</h4>
						</div>
					</div>

					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i class="nav-icon fas fa-map"></i
												>&nbsp;&nbsp;Masters&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">
										&nbsp;&nbsp;National Locations&nbsp;&nbsp;
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<!-- selected-class="bg-blue-custom text-white" -->
					<v-card>
						<v-tabs
							v-model="activeTab"
							density="compact"
							align-tabs="center"
							color="SteelBlue"
						>
							<v-tab :value="1">Districts</v-tab>
							<v-tab :value="2">Neighbours</v-tab>
							<v-tab :value="3">Towns</v-tab>
							<v-tab :value="4">National Parks</v-tab>
						</v-tabs>

						<v-window v-model="activeTab">
							<v-window-item :value="1">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('district')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
												District
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="districtHeaders"
											:items="districtsComputed"
											:items-per-page="districtPerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.district_name }}</td>
													<td>{{ item.district_code }}</td>
													<td>{{ item.region }}</td>
													<td class="">
														<button
															class="btn btn-sm btn-outline-primary me-1"
															@click="manageDistricts(item, 'edit')"
														>
															Edit
														</button>
														<button
															class="btn btn-sm btn-outline-danger"
															@click="manageDistricts(item, 'delete')"
														>
															Delete
														</button>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>

							<v-window-item :value="2">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('neighbour')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
												Neighbour
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="neighbourHeaders"
											:items="neighboursComputed"
											:items-per-page="neighbourPerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.district_name }}</td>
													<td>{{ item.direction_id }}</td>
													<td>{{ item.desc }}</td>
													<td class="">
														<button
															class="btn btn-sm btn-outline-primary me-1"
															@click="manageNeighbours(item, 'edit')"
														>
															Edit
														</button>
														<button
															class="btn btn-sm btn-outline-danger"
															@click="manageNeighbours(item, 'delete')"
														>
															Delete
														</button>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>

							<v-window-item :value="3">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('town')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add Town
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="townHeaders"
											:items="townsComputed"
											:items-per-page="townPerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.town_name }}</td>
													<td>{{ item.town_code }}</td>
													<td>{{ item.district_name }}</td>
													<td>{{ item.desc }}</td>
													<td class="">
														<button
															class="btn btn-sm btn-outline-primary me-1"
															@click="manageTowns(item, 'edit')"
														>
															Edit
														</button>
														<button
															class="btn btn-sm btn-outline-danger"
															@click="manageTowns(item, 'delete')"
														>
															Delete
														</button>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>

							<v-window-item :value="4">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12 m-1">
										<div class="col-sm-7 float-sm-left text-start">
											<h5
												class="text-dark mb-3"
												style="font-family: NunitoBlack"
											>
												National Parks
											</h5>
										</div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('parks')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add Park
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="parkHeaders"
											:items="parksComputed"
											:items-per-page="parkPerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.name }}</td>
													<td>{{ item.code }}</td>
													<td>{{ item.region }}</td>
													<td class="">
														<button
															class="btn btn-sm btn-outline-primary me-1"
															@click="manageNationalParks(item, 'edit')"
														>
															Edit
														</button>
														<button
															class="btn btn-sm btn-outline-danger"
															@click="manageNationalParks(item, 'delete')"
														>
															Delete
														</button>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>

									<div class="row col-sm-12 mt-4 m-1">
										<div class="row col-sm-12 m-1">
											<div class="col-sm-7 float-sm-left text-start">
												<h5
													class="text-dark mb-3"
													style="font-family: NunitoBlack"
												>
													Park Districts
												</h5>
											</div>
											<div
												class="col-sm-5 text-end"
												style="font-family: HeaderCustomFont"
											>
												<button
													class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
													@click="openModal('parkdistrict')"
												>
													<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
													Park District
												</button>
											</div>
										</div>
										<div class="row col-sm-12 mt-2 m-1">
											<v-data-table
												:headers="parkDistrictHeaders"
												:items="parkDistrictsComputed"
												:items-per-page="parkDistrictPerPage"
												density="compact"
												item-value="name"
												class="table-sm table-striped rounded-0 table-responsive table-wrap"
											>
												<template v-slot:body="{ items }">
													<tr
														class="align-top"
														v-for="(item, index) in items"
														:key="item.id"
													>
														<td>{{ item.index }}</td>
														<td>{{ item.district_name }}</td>
														<td>{{ item.direction_id }}</td>
														<td>{{ item.desc }}</td>
														<td class="">
															<button
																class="btn btn-sm btn-outline-primary me-1"
																@click="manageParkDistricts(item, 'edit')"
															>
																Edit
															</button>
															<button
																class="btn btn-sm btn-outline-danger"
																@click="manageParkDistricts(item, 'delete')"
															>
																Delete
															</button>
														</td>
													</tr>
												</template>
											</v-data-table>
										</div>
									</div>
								</div>
							</v-window-item>
						</v-window>
					</v-card>
				</div>
			</div>

			<!-- District Modal -->
			<v-dialog v-model="districtModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageDistricts(districtForm, 'update')
							: manageDistricts(districtForm, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-building" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										District
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('district')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="district_name" class="form-label"
													><span v-if="districtForm.errors.has('district_name')"
														>{{
															districtForm.errors.get("district_name")
														}} </span
													><span v-else>District Name</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="district_name"
													v-model="districtForm.district_name"
													placeholder="Enter District Name"
													variant="outlined"
													:class="{
														'required-error':
															districtForm.errors.has('district_name'),
													}"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="district_code" class="form-label"
													><span v-if="districtForm.errors.has('district_code')"
														>{{
															districtForm.errors.get("district_code")
														}} </span
													><span v-else>District Code</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="district_code"
													v-model="districtForm.district_code"
													placeholder="Enter District Code"
													variant="outlined"
													type="number"
													:class="{
														'required-error':
															districtForm.errors.has('district_code'),
													}"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="region" class="form-label"
													><span v-if="districtForm.errors.has('region')"
														>{{ districtForm.errors.get("region") }} </span
													><span v-else>Region</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="region"
													v-model="districtForm.region"
													placeholder="Enter Region"
													variant="outlined"
													:class="{
														'required-error': districtForm.errors.has('region'),
													}"
												></v-text-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save District
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('district')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>

			<!-- Town Modal -->
			<v-dialog v-model="townModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageTowns(townForm, 'update')
							: manageTowns(townForm, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-city" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										Town
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('town')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="town_name" class="form-label"
													><span v-if="townForm.errors.has('town_name')"
														>{{ townForm.errors.get("town_name") }} </span
													><span v-else>Town Name</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="town_name"
													v-model="townForm.town_name"
													placeholder="Enter Town Name"
													variant="outlined"
													:class="{
														'required-error': townForm.errors.has('town_name'),
													}"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="town_code" class="form-label"
													><span v-if="townForm.errors.has('town_code')"
														>{{ townForm.errors.get("town_code") }} </span
													><span v-else>Town Code</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="town_code"
													v-model="townForm.town_code"
													placeholder="Enter Town Code"
													variant="outlined"
													type="number"
													:class="{
														'required-error': townForm.errors.has('town_code'),
													}"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="district_id" class="form-label"
													><span v-if="townForm.errors.has('district_id')"
														>{{ townForm.errors.get("district_id") }} </span
													><span v-else>District</span></label
												>
												<v-select
													density="compact"
													rounded="0"
													id="district_id"
													v-model="townForm.district_id"
													:items="infiniteDistricts"
													item-title="district_name"
													item-value="id"
													placeholder="Select District"
													variant="outlined"
													:class="{
														'required-error':
															townForm.errors.has('district_id'),
													}"
												></v-select>
											</div>
										</div>
										<div class="col-md-12">
											<div class="mb-3">
												<label for="desc" class="form-label"
													><span v-if="townForm.errors.has('desc')"
														>{{ townForm.errors.get("desc") }} </span
													><span v-else>Description</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="desc"
													v-model="townForm.desc"
													placeholder="Enter Description"
													variant="outlined"
												></v-text-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Town
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('town')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>

			<!-- Neighbour Modal -->
			<v-dialog v-model="neighbourModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageNeighbours(neighbourForm, 'update')
							: manageNeighbours(neighbourForm, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-arrows-alt" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										Neighbour
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('neighbour')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="district_id" class="form-label"
													><span v-if="neighbourForm.errors.has('district_id')"
														>{{
															neighbourForm.errors.get("district_id")
														}} </span
													><span v-else>District</span></label
												>
												<v-select
													density="compact"
													rounded="0"
													id="district_id"
													v-model="neighbourForm.district_id"
													:items="infiniteDistricts"
													item-title="district_name"
													item-value="id"
													placeholder="Select District"
													variant="outlined"
													:class="{
														'required-error':
															neighbourForm.errors.has('district_id'),
													}"
												></v-select>
											</div>
										</div>
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="direction_id" class="form-label"
													><span v-if="neighbourForm.errors.has('direction_id')"
														>{{
															neighbourForm.errors.get("direction_id")
														}} </span
													><span v-else>Direction ID</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="direction_id"
													v-model="neighbourForm.direction_id"
													placeholder="Enter Direction ID"
													variant="outlined"
													type="number"
													:class="{
														'required-error':
															neighbourForm.errors.has('direction_id'),
													}"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-12">
											<div class="mb-3">
												<label for="desc" class="form-label"
													><span v-if="neighbourForm.errors.has('desc')"
														>{{ neighbourForm.errors.get("desc") }} </span
													><span v-else>Description</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="desc"
													v-model="neighbourForm.desc"
													placeholder="Enter Description"
													variant="outlined"
												></v-text-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Neighbour
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('neighbour')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>

			<v-dialog v-model="parksModal" max-width="800px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageNationalParks(parkForm, 'update')
							: manageNationalParks(parkForm, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-tree" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										National Park
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('parks')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="name" class="form-label"
													><span v-if="parkForm.errors.has('name')"
														>{{ parkForm.errors.get("name") }} </span
													><span v-else>Name</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="name"
													v-model="parkForm.name"
													placeholder="Enter Name"
													variant="outlined"
													:class="{
														'required-error': parkForm.errors.has('name'),
													}"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="code" class="form-label"
													><span v-if="parkForm.errors.has('code')"
														>{{ parkForm.errors.get("code") }} </span
													><span v-else>Code</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="code"
													v-model="parkForm.code"
													placeholder="Enter Code"
													variant="outlined"
													:class="{
														'required-error': parkForm.errors.has('code'),
													}"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="region" class="form-label"
													><span v-if="parkForm.errors.has('region')"
														>{{ parkForm.errors.get("region") }} </span
													><span v-else>Region</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="region"
													v-model="parkForm.region"
													placeholder="Enter Region"
													variant="outlined"
													:class="{
														'required-error': parkForm.errors.has('region'),
													}"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-12">
											<div class="mb-3">
												<label for="description" class="form-label"
													><span v-if="parkForm.errors.has('description')"
														>{{ parkForm.errors.get("description") }} </span
													><span v-else>Description</span></label
												>
												<v-textarea
													density="compact"
													rounded="0"
													id="description"
													v-model="parkForm.description"
													placeholder="Enter Description"
													variant="outlined"
													rows="4"
												></v-textarea>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Park
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('parks')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>

			<v-dialog v-model="parkDistrictModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageParkDistricts(parkDistrictForm, 'update')
							: manageParkDistricts(parkDistrictForm, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon
											icon="fas fa-map-marked-alt"
										/>&nbsp;&nbsp;{{ editMode ? "Edit" : "Add" }}
										Park District
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('parkdistrict')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="district_id_pd" class="form-label"
													><span
														v-if="parkDistrictForm.errors.has('district_id')"
														>{{
															parkDistrictForm.errors.get("district_id")
														}} </span
													><span v-else>District</span></label
												>
												<v-select
													density="compact"
													rounded="0"
													id="district_id_pd"
													v-model="parkDistrictForm.district_id"
													:items="infiniteDistricts"
													item-title="district_name"
													item-value="id"
													placeholder="Select District"
													variant="outlined"
													:class="{
														'required-error':
															parkDistrictForm.errors.has('district_id'),
													}"
												></v-select>
											</div>
										</div>
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="direction_id_pd" class="form-label"
													><span
														v-if="parkDistrictForm.errors.has('direction_id')"
														>{{
															parkDistrictForm.errors.get("direction_id")
														}} </span
													><span v-else>Direction ID</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="direction_id_pd"
													v-model="parkDistrictForm.direction_id"
													placeholder="Enter Direction ID"
													variant="outlined"
													type="number"
													:class="{
														'required-error':
															parkDistrictForm.errors.has('direction_id'),
													}"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-12">
											<div class="mb-3">
												<label for="desc_pd" class="form-label"
													><span v-if="parkDistrictForm.errors.has('desc')"
														>{{ parkDistrictForm.errors.get("desc") }} </span
													><span v-else>Description</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="desc_pd"
													v-model="parkDistrictForm.desc"
													placeholder="Enter Description"
													variant="outlined"
												></v-text-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Park
										District
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('parkdistrict')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	components: {},
	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			message: "",
			http_code: "",
			user: [],
			activeTab: 1,
			districtModal: false,
			townModal: false,
			neighbourModal: false,
			parksModal: false,
			editMode: false,
			districtForm: new Form({
				id: "",
				district_name: "",
				district_code: "",
				region: "",
			}),
			townForm: new Form({
				id: "",
				town_name: "",
				town_code: "",
				district_id: null,
				desc: "",
			}),
			neighbourForm: new Form({
				id: "",
				district_id: null,
				direction_id: null,
				desc: "",
			}),
			infiniteDistricts: [],
			infiniteTowns: [],
			infiniteNeighbours: [],
			districts: [],
			towns: [],
			neighbours: [],
			districtPerPage: 10,
			townPerPage: 10,
			neighbourPerPage: 10,
			districtHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "District Name", value: "district_name", sortable: true },
				{ title: "District Code", value: "district_code", sortable: true },
				{ title: "Region", value: "region", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			townHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Town Name", value: "town_name", sortable: true },
				{ title: "Town Code", value: "town_code", sortable: true },
				{ title: "District", value: "district_name", sortable: true },
				{ title: "Description", value: "desc", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			neighbourHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "District", value: "district_name", sortable: true },
				{ title: "Direction ID", value: "direction_id", sortable: true },
				{ title: "Description", value: "desc", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			parksModal: false,
			editMode: false,
			parkPerPage: 10,
			parks: [],
			infiniteDistricts: [],
			parkHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Name", value: "name", sortable: true },
				{ title: "Code", value: "code", sortable: true },
				{ title: "Region", value: "region", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			parkForm: new Form({
				id: "",
				name: "",
				code: "",
				region: "",
				description: "",
				is_deleted: 0,
			}),
			parkDistrictModal: false,
			parkDistrictForm: new Form({
				id: "",
				district_id: null,
				direction_id: null,
				desc: "",
			}),
			parkDistricts: [],
			parkDistrictPerPage: 10,
			parkDistrictHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "District", value: "district_name", sortable: true },
				{ title: "Direction ID", value: "direction_id", sortable: true },
				{ title: "Description", value: "desc", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
		};
	},
	methods: {
		async getUser() {
			var user_id = localStorage.getItem("user_id");
			if (user_id) {
				var api = this.api + "/user/" + user_id;
				const query = await this.getData(api);
				if (query.result == "success") {
					this.user = query.response.data;
				}
			}
		},
		openModal(modal) {
			this.editMode = false;
			if (modal == "district") {
				this.districtModal = true;
				this.districtForm.reset();
			} else if (modal == "town") {
				this.townModal = true;
				this.townForm.reset();
			} else if (modal == "neighbour") {
				this.neighbourModal = true;
				this.neighbourForm.reset();
			} else if (modal === "parks") {
				this.editMode = false;
				this.parksModal = true;
			} else if (modal === "parkdistrict") {
				this.editMode = false;
				this.parkDistrictModal = true;
			}
		},
		closeModal(modal) {
			if (modal == "district") {
				this.districtModal = false;
				this.districtForm.reset();
				this.districtForm.errors.clear();
			} else if (modal == "town") {
				this.townModal = false;
				this.townForm.reset();
				this.townForm.errors.clear();
			} else if (modal == "neighbour") {
				this.neighbourModal = false;
				this.neighbourForm.reset();
				this.neighbourForm.errors.clear();
			} else if (modal === "parks") {
				this.editMode = false;
				this.parksModal = false;
				this.parkForm.reset();
				this.parkForm.errors.clear();
			} else if (modal === "parkdistrict") {
				this.editMode = false;
				this.parkDistrictModal = false;
				this.parkDistrictForm.reset();
				this.parkDistrictForm.errors.clear();
			}
			this.editMode = false;
		},
		async getInfinites(mode) {
			var query, api;
			if (mode == "districts") {
				api = this.api + this.prefix + "/masters/districts";
				query = await this.getData(api);
				if (query.result == "success") {
					this.infiniteDistricts = query.response;
				}
			} else if (mode == "towns") {
				api = this.api + this.prefix + "/masters/towns";
				query = await this.getData(api);
				if (query.result == "success") {
					this.infiniteTowns = query.response;
				}
			} else if (mode == "neighbours") {
				api = this.api + this.prefix + "/masters/neighbours";
				query = await this.getData(api);
				if (query.result == "success") {
					this.infiniteNeighbours = query.response;
				}
			} else if (mode === "parks") {
				api = this.api + this.prefix + "/masters/parks";
				query = await this.getData(api);
				this.message = query.response ? query.response.message : "";
				this.http_code = query.code;
				if (query.result === "success") {
					this.parks = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode === "districts") {
				api = this.api + this.prefix + "/masters/districts";
				query = await this.getData(api);
				if (query.result === "success") {
					this.infiniteDistricts = query.response;
				}
			} else if (mode === "parkdistricts") {
				api = this.api + this.prefix + "/masters/parkdistricts";
				query = await this.getData(api);
				if (query.result === "success") {
					this.parkDistricts = query.response;
				}
			}
		},
		async manageDistricts(event, mode) {
			var query, api;
			if (mode == "fetch") {
				await this.getInfinites("districts");
				this.districts = this.infiniteDistricts;
			} else if (mode == "insert") {
				this.districtForm.created_by = this.user.id;
				api = this.api + this.prefix + "/masters/districts";
				query = await this.postData(api, this.districtForm);
				if (query.result == "success") {
					this.showMessage("District added successfully");
					this.closeModal("district");
					this.manageDistricts(null, "fetch");
				} else {
					this.showError(query.response.message, query.code);
				}
			} else if (mode == "update") {
				this.districtForm.updated_by = this.user.id;
				api =
					this.api + this.prefix + "/masters/districts/" + this.districtForm.id;
				query = await this.putData(api, this.districtForm);
				if (query.result == "success") {
					this.showMessage("District updated successfully");
					this.closeModal("district");
					this.manageDistricts(null, "fetch");
				} else {
					this.showError(query.response.message, query.code);
				}
			} else if (mode == "edit") {
				this.districtForm.reset();
				this.districtForm.fill(event);
				this.editMode = true;
				this.openModal("district");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation("Delete this District?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/masters/districts/" + event.id;
					query = await this.deleteData(api);
					if (query.result == "success") {
						this.showMessage("District deleted successfully");
						this.manageDistricts(null, "fetch");
					} else {
						this.showError(query.response.message, query.code);
					}
				}
			}
		},
		async manageTowns(event, mode) {
			var query, api;
			if (mode == "fetch") {
				await this.getInfinites("towns");
				this.towns = this.infiniteTowns;
			} else if (mode == "insert") {
				this.townForm.created_by = this.user.id;
				api = this.api + this.prefix + "/masters/towns";
				query = await this.postData(api, this.townForm);
				if (query.result == "success") {
					this.showMessage("Town added successfully");
					this.closeModal("town");
					this.manageTowns(null, "fetch");
				} else {
					this.showError(query.response.message, query.code);
				}
			} else if (mode == "update") {
				this.townForm.updated_by = this.user.id;
				api = this.api + this.prefix + "/masters/towns/" + this.townForm.id;
				query = await this.putData(api, this.townForm);
				if (query.result == "success") {
					this.showMessage("Town updated successfully");
					this.closeModal("town");
					this.manageTowns(null, "fetch");
				} else {
					this.showError(query.response.message, query.code);
				}
			} else if (mode == "edit") {
				this.townForm.reset();
				this.townForm.fill(event);
				this.editMode = true;
				this.openModal("town");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation("Delete this Town?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/masters/towns/" + event.id;
					query = await this.deleteData(api);
					if (query.result == "success") {
						this.showMessage("Town deleted successfully");
						this.manageTowns(null, "fetch");
					} else {
						this.showError(query.response.message, query.code);
					}
				}
			}
		},
		async manageNeighbours(event, mode) {
			var query, api;
			if (mode == "fetch") {
				await this.getInfinites("neighbours");
				this.neighbours = this.infiniteNeighbours;
			} else if (mode == "insert") {
				this.neighbourForm.created_by = this.user.id;
				api = this.api + this.prefix + "/masters/neighbours";
				query = await this.postData(api, this.neighbourForm);
				if (query.result == "success") {
					this.showMessage("Neighbour added successfully");
					this.closeModal("neighbour");
					this.manageNeighbours(null, "fetch");
				} else {
					this.showError(query.response.message, query.code);
				}
			} else if (mode == "update") {
				this.neighbourForm.updated_by = this.user.id;
				api =
					this.api +
					this.prefix +
					"/masters/neighbours/" +
					this.neighbourForm.id;
				query = await this.putData(api, this.neighbourForm);
				if (query.result == "success") {
					this.showMessage("Neighbour updated successfully");
					this.closeModal("neighbour");
					this.manageNeighbours(null, "fetch");
				} else {
					this.showError(query.response.message, query.code);
				}
			} else if (mode == "edit") {
				this.neighbourForm.reset();
				this.neighbourForm.fill(event);
				this.editMode = true;
				this.openModal("neighbour");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation(
					"Delete this Neighbour?"
				);
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/masters/neighbours/" + event.id;
					query = await this.deleteData(api);
					if (query.result == "success") {
						this.showMessage("Neighbour deleted successfully");
						this.manageNeighbours(null, "fetch");
					} else {
						this.showError(query.response.message, query.code);
					}
				}
			}
		},
		async manageNationalParks(event, mode) {
			let api, query;
			if (mode === "fetch") {
				api = this.api + this.prefix + "/masters/parks";
				query = await this.getData(api);
				this.message = query.response ? query.response.message : "";
				this.http_code = query.code;
				if (query.result === "success") {
					this.parks = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode === "insert") {
				api = this.api + this.prefix + "/masters/parks";
				query = await this.postData(api, this.parkForm);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result === "success") {
					this.showMessage(this.message);
					this.closeModal("parks");
					this.manageNationalParks(null, "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode === "update") {
				api = this.api + this.prefix + "/masters/parks/" + event.id;
				query = await this.putData(api, this.parkForm);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result === "success") {
					this.showMessage(this.message);
					this.closeModal("parks");
					this.manageNationalParks(null, "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode === "edit") {
				this.parkForm.reset();
				this.parkForm.fill(event);
				this.editMode = true;
				this.parksModal = true;
			} else if (mode === "delete") {
				let confirmation = await this.showConfirmation("Delete this Park?");
				if (confirmation.result === "Yes") {
					api = this.api + this.prefix + "/masters/parks/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result === "success") {
						this.showMessage(this.message);
						this.manageNationalParks(null, "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageParkDistricts(event, mode) {
			let api, query;
			if (mode === "fetch") {
				api = this.api + this.prefix + "/masters/park-districts";
				query = await this.getData(api);
				this.message = query.response ? query.response.message : "";
				this.http_code = query.code;
				if (query.result === "success") {
					this.parkDistricts = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode === "insert") {
				api = this.api + this.prefix + "/masters/park-districts";
				query = await this.postData(api, this.parkDistrictForm);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result === "success") {
					this.showMessage(this.message);
					this.closeModal("parkdistrict");
					this.manageParkDistricts(null, "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode === "update") {
				api = this.api + this.prefix + "/masters/park-districts/" + event.id;
				query = await this.putData(api, this.parkDistrictForm);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result === "success") {
					this.showMessage(this.message);
					this.closeModal("parkdistrict");
					this.manageParkDistricts(null, "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode === "edit") {
				this.parkDistrictForm.reset();
				this.parkDistrictForm.fill(event);
				this.editMode = true;
				this.parkDistrictModal = true;
			} else if (mode === "delete") {
				let confirmation = await this.showConfirmation(
					"Delete this Park District?"
				);
				if (confirmation.result === "Yes") {
					api = this.api + this.prefix + "/masters/park-districts/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result === "success") {
						this.showMessage(this.message);
						this.manageParkDistricts(null, "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
	},
	computed: {
		currentRoute() {
			return this.$route.path.includes("/masters/");
		},
		districtsComputed() {
			return this.districts.map((district, index) => {
				district.index = index + 1;
				return district;
			});
		},
		townsComputed() {
			return this.towns.map((town, index) => {
				town.index = index + 1;
				const district = this.infiniteDistricts.find(
					(d) => d.id == town.district_id
				);
				town.district_name = district ? district.district_name : "";
				return town;
			});
		},
		neighboursComputed() {
			return this.neighbours.map((neighbour, index) => {
				neighbour.index = index + 1;
				const district = this.infiniteDistricts.find(
					(d) => d.id == neighbour.district_id
				);
				neighbour.district_name = district ? district.district_name : "";
				return neighbour;
			});
		},
		parksComputed() {
			return this.parks.map((park, index) => {
				park.index = index + 1;
				return park;
			});
		},
		parkDistrictsComputed() {
			return this.parkDistricts.map((parkDistrict, index) => {
				parkDistrict.index = index + 1;
				const district = this.infiniteDistricts.find(
					(d) => d.id == parkDistrict.district_id
				);
				parkDistrict.district_name = district ? district.district_name : "";
				return parkDistrict;
			});
		},
	},
	created() {
		this.getUser();
		this.getInfinites("districts");
		this.getInfinites("towns");
		this.getInfinites("neighbours");
		this.manageDistricts(null, "fetch");
		this.manageTowns(null, "fetch");
		this.manageNeighbours(null, "fetch");
		this.manageNationalParks(null, "fetch");
		this.manageParkDistricts(null, "fetch");
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>